<script lang="ts">
import { inject } from 'vue';

import { PhxsgIcon as PhxsgCoreIcon } from '@sg-core/src/View/Components/Atoms/Icon';

import type { HTMLAttributes } from 'vue';

export interface PhxsgAutocompleteButtonAttrs {
  class?: HTMLAttributes['class'];
  'aria-controls'?: string;
  'aria-expanded'?: boolean;
  'aria-label': string;
  tabindex: number;
}

export interface PhxsgAutocompleteButtonEvents {
  onClick: (e: MouseEvent) => void;
  onBlur: () => void;
  onMousedown: () => void;
  onKeydown: (e: KeyboardEvent) => void;
}

interface Props {
  buttonAttrs: PhxsgAutocompleteButtonAttrs;
  buttonEvents: PhxsgAutocompleteButtonEvents;
  icon?: string | false;
  type?: 'open' | 'clear';
  label: string;
}
</script>

<script setup lang="ts">
const { type = 'open' } = defineProps<Props>();

const PhxsgIcon = inject('PhxsgIcon', PhxsgCoreIcon);
</script>

<template>
  <button
    v-bind="{ ...buttonAttrs, ...buttonEvents }"
    :aria-label="label"
    :class="['phxsg-autocomplete__button', `phxsg-autocomplete__button--${type}`]"
  >
    <PhxsgIcon v-if="icon" :id="icon" />
    <svg
      v-else-if="icon !== false"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
      role="img"
    >
      <path v-if="type === 'open'" d="M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z" fill="currentColor" />
      <path
        v-else
        d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
        fill="currentColor"
      />
    </svg>
  </button>
</template>
